<div class="container-fluid">
    <div class="row">
        <div class="col-12 p-0">
            <div class="card-save col-sm-12 d-flex flex-wrap">
                <div class="col-sm-4 layout-banner d-flex">
                    <div class="banner-register">
                        <form class="theme-form">
                            <h2 class="text-center">INVOICEX</h2>
                            <p class="mt-4 mb-0 text-center fs-6">
                                Chào mừng quý khách đến với INVOICEX. <br>
                                Vui lòng đăng kí thông tin để được tận hưởng <br> các dich vụ tốt nhất của chúng tôi.
                            </p>
                            <p class="mt-4 mb-0 text-center fs-6">Nếu đã có tài khoản, vui lòng đăng nhập <RouterLink to="/login">TẠI ĐÂY.</RouterLink></p>
                        </form>
                    </div>
                </div>
                <div class="col-sm-8 layout-register">
                    <div class="title text-center">
                        <h3>ĐĂNG KÍ TÀI KHOẢN</h3>
                    </div>
                    <div class="col-sm-12 d-flex mt-4 mb-4 progress-box">
                        <ProgressBarNormal :list-step="stepRegister" :step="step"></ProgressBarNormal>
                    </div>
                    <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="errorMessage !== undefined && errorMessage.length > 0" v-for="(error, key) in errorMessage" :key="error">
                        <span>{{error}}</span>
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="removeError(key)">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="form-register col-sm-12 d-flex flex-column gap-5 align-items-center">
                        <form class="col-sm-12 d-flex align-items-center flex-column" v-if="step === 1">
                            <h5 class="card-title">THÔNG TIN CÔNG TY</h5>
                            <div class="card-body col-sm-12">
                                <div class="col-sm-12 d-flex flex-column align-items-center">
                                    <div class="col-sm-8">
                                        <InputTextNormal
                                                :label="dataRegister.name_company.label"
                                                :id="dataRegister.name_company.id"
                                                :placeholder="dataRegister.name_company.placeholder"
                                                :value-default="dataRegister.name_company.value"
                                                @inputValue="onChange($event, dataRegister.name_company.id)"
                                                :error-text="dataRegister.name_company.error"
                                                :is-error="dataRegister.name_company.isError"
                                                @blur="validateFormCompany($event, dataRegister.name_company.id)"
                                                :required="dataRegister.name_company.required"
                                        ></InputTextNormal>
                                    </div>
                                    <div class="col-sm-8">
                                        <InputTextNormal
                                                :label="dataRegister.code_company.label"
                                                :id="dataRegister.code_company.id"
                                                :placeholder="dataRegister.code_company.placeholder"
                                                :value-default="dataRegister.code_company.value"
                                                @inputValue="onChange($event, dataRegister.code_company.id)"
                                                :error-text="dataRegister.code_company.error"
                                                :is-error="dataRegister.code_company.isError"
                                                @blur="validateFormCompany($event, dataRegister.code_company.id)"
                                                :required="dataRegister.code_company.required"
                                        ></InputTextNormal>
                                    </div>
                                    <div class="col-sm-8">
                                        <InputTextNormal
                                                :label="dataRegister.email_company.label"
                                                :id="dataRegister.email_company.id"
                                                :placeholder="dataRegister.email_company.placeholder"
                                                :value-default="dataRegister.email_company.value"
                                                @inputValue="onChange($event, dataRegister.email_company.id)"
                                                :error-text="dataRegister.email_company.error"
                                                :is-error="dataRegister.email_company.isError"
                                                @blur="validateFormCompany($event, dataRegister.email_company.id)"
                                                :required="dataRegister.email_company.required"
                                        ></InputTextNormal>
                                    </div>
                                    <div class="col-sm-8">
                                        <InputTextNormal
                                                :label="dataRegister.phone_company.label"
                                                :id="dataRegister.phone_company.id"
                                                :placeholder="dataRegister.phone_company.placeholder"
                                                :value-default="dataRegister.phone_company.value"
                                                @inputValue="onChange($event, dataRegister.phone_company.id)"
                                                :error-text="dataRegister.phone_company.error"
                                                :is-error="dataRegister.phone_company.isError"
                                                @blur="validateFormCompany($event, dataRegister.phone_company.id)"
                                                :required="dataRegister.phone_company.required"
                                        ></InputTextNormal>
                                    </div>
                                    <div class="col-sm-8">
                                        <InputTextNormal
                                                :label="dataRegister.addr_company.label"
                                                :id="dataRegister.addr_company.id"
                                                :placeholder="dataRegister.addr_company.placeholder"
                                                :value-default="dataRegister.addr_company.value"
                                                @inputValue="onChange($event, dataRegister.addr_company.id)"
                                                :error-text="dataRegister.addr_company.error"
                                                :is-error="dataRegister.addr_company.isError"
                                                @blur="validateFormCompany($event, dataRegister.addr_company.id)"
                                                :required="dataRegister.addr_company.required"
                                        ></InputTextNormal>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-2 d-flex justify-content-center gap-5 mt-4">
                                <ButtonNextComponent :label="labelBtnStepNext" @click="nextStep(step)"></ButtonNextComponent>
                            </div>
                        </form>
                        <form class="col-sm-12 d-flex align-items-center flex-column" v-if="step === 2">
                            <h5 class="card-title">THÔNG TIN TÀI KHOẢN</h5>
                            <div class="card-body col-sm-12">
                                <div class="col-sm-12 d-flex flex-column align-items-center">
                                    <div class="col-sm-8">
                                        <InputTextNormal
                                                :label="dataRegister.user_name.label"
                                                :id="dataRegister.user_name.id"
                                                :placeholder="dataRegister.user_name.placeholder"
                                                :value-default="dataRegister.user_name.value"
                                                @inputValue="onChange($event, dataRegister.user_name.id)"
                                                :error-text="dataRegister.user_name.error"
                                                :is-error="dataRegister.user_name.isError"
                                                @blur="validateFormUser($event, dataRegister.user_name.id)"
                                                :required="dataRegister.user_name.required"
                                        ></InputTextNormal>
                                    </div>
                                    <div class="col-sm-8">
                                        <InputTextNormal
                                                :label="dataRegister.user_phone.label"
                                                :id="dataRegister.user_phone.id"
                                                :placeholder="dataRegister.user_phone.placeholder"
                                                :value-default="dataRegister.user_phone.value"
                                                @inputValue="onChange($event, dataRegister.user_phone.id)"
                                                :error-text="dataRegister.user_phone.error"
                                                :is-error="dataRegister.user_phone.isError"
                                                @blur="validateFormUser($event, dataRegister.user_phone.id)"
                                                :required="dataRegister.user_phone.required"
                                        ></InputTextNormal>
                                    </div>
                                    <div class="col-sm-8">
                                        <InputTextNormal
                                                :label="dataRegister.user_email.label"
                                                :id="dataRegister.user_email.id"
                                                :placeholder="dataRegister.user_email.placeholder"
                                                :value-default="dataRegister.user_email.value"
                                                @inputValue="onChange($event, dataRegister.user_email.id)"
                                                :error-text="dataRegister.user_email.error"
                                                :is-error="dataRegister.user_email.isError"
                                                @blur="validateFormUser($event, dataRegister.user_email.id)"
                                                :required="dataRegister.user_email.required"
                                        ></InputTextNormal>
                                    </div>
                                    <div class="col-sm-8">
                                        <InputPasswordNormal
                                                :label="dataRegister.user_password.label"
                                                :id="dataRegister.user_password.id"
                                                :placeholder="dataRegister.user_password.placeholder"
                                                :value-default="dataRegister.user_password.value"
                                                @inputValue="onChange($event, dataRegister.user_password.id)"
                                                :error-text="dataRegister.user_password.error"
                                                :is-error="dataRegister.user_password.isError"
                                                @blur="validateFormUser($event, dataRegister.user_password.id)"
                                                :required="dataRegister.user_password.required"
                                        ></InputPasswordNormal>
                                    </div>
                                    <div class="col-sm-8">
                                        <InputPasswordNormal
                                                :label="dataRegister.user_password_confirm.label"
                                                :id="dataRegister.user_password_confirm.id"
                                                :placeholder="dataRegister.user_password_confirm.placeholder"
                                                :value-default="dataRegister.user_password_confirm.value"
                                                @inputValue="onChange($event, dataRegister.user_password_confirm.id)"
                                                :error-text="dataRegister.user_password_confirm.error"
                                                :is-error="dataRegister.user_password_confirm.isError"
                                                @blur="validateFormUser($event, dataRegister.user_password_confirm.id)"
                                                :required="dataRegister.user_password_confirm.required"
                                        ></InputPasswordNormal>
                                    </div>
                                    <div class="col-sm-8">
                                        <SelectNormal
                                                :label="dataRegister.user_gender.label"
                                                :id="dataRegister.user_gender.id"
                                                :placeholder="dataRegister.user_gender.placeholder"
                                                :value-default="dataRegister.user_gender.value"
                                                :options="dataRegister.user_gender.options"
                                        ></SelectNormal>
                                    </div>
                                    <div class="col-sm-8">
                                        <InputDateTimeNormal
                                            :label="dataRegister.user_birthday.label"
                                            :id="dataRegister.user_birthday.id"
                                            :placeholder="dataRegister.user_birthday.placeholder"
                                            :value-default="dataRegister.user_birthday.value"
                                            @inputValue="onChange($event, dataRegister.user_birthday.id)"
                                            :error-text="dataRegister.user_birthday.error"
                                            :is-error="dataRegister.user_birthday.isError"
                                            @blur="validateFormUser($event, dataRegister.user_birthday.id)"
                                            :required="dataRegister.user_birthday.required"
                                        >
                                        </InputDateTimeNormal>
                                    </div>
                                    <div class="col-sm-8">
                                        <InputTextNormal
                                                :label="dataRegister.user_addr.label"
                                                :id="dataRegister.user_addr.id"
                                                :placeholder="dataRegister.user_addr.placeholder"
                                                :value-default="dataRegister.user_addr.value"
                                                @inputValue="onChange($event, dataRegister.user_addr.id)"
                                                :error-text="dataRegister.user_addr.error"
                                                :is-error="dataRegister.user_addr.isError"
                                                @blur="validateFormUser($event, dataRegister.user_addr.id)"
                                                :required="dataRegister.user_addr.required"
                                        ></InputTextNormal>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-8 d-flex justify-content-center gap-5 mt-4">
                                <ButtonBackComponent :label="labelBtnStepBack" @click="backProcess(step)"></ButtonBackComponent>
                                <ButtonNextComponent :label="labelBtnStepNext" @click="nextStep(step)"></ButtonNextComponent>
                            </div>
                        </form>
                        <form class="col-sm-12 d-flex align-items-center flex-column" v-if="step === 3">
                            <h5 class="card-title">THÔNG TIN CỬA HÀNG</h5>
                            <div class="card-body col-sm-12">
                                <div class="col-sm-12 d-flex flex-column align-items-center">
                                    <div class="col-sm-8">
                                        <InputTextNormal
                                                :label="dataRegister.name_store.label"
                                                :id="dataRegister.name_store.id"
                                                :placeholder="dataRegister.name_store.placeholder"
                                                :value-default="dataRegister.name_store.value"
                                                @inputValue="onChange($event, dataRegister.name_store.id)"
                                                :error-text="dataRegister.name_store.error"
                                                :is-error="dataRegister.name_store.isError"
                                                @blur="validateFormUser($event, dataRegister.name_store.id)"
                                                :required="dataRegister.name_store.required"
                                        ></InputTextNormal>
                                    </div>
                                    <div class="col-sm-8">
                                        <InputTextNormal
                                                :label="dataRegister.code_store.label"
                                                :id="dataRegister.code_store.id"
                                                :placeholder="dataRegister.code_store.placeholder"
                                                :value-default="dataRegister.code_store.value"
                                                @inputValue="onChange($event, dataRegister.code_store.id)"
                                                :error-text="dataRegister.code_store.error"
                                                :is-error="dataRegister.code_store.isError"
                                                @blur="validateFormUser($event, dataRegister.code_store.id)"
                                                :required="dataRegister.code_store.required"
                                        ></InputTextNormal>
                                    </div>
                                    <div class="col-sm-8">
                                        <InputTextNormal
                                                :label="dataRegister.phone_store.label"
                                                :id="dataRegister.phone_store.id"
                                                :placeholder="dataRegister.phone_store.placeholder"
                                                :value-default="dataRegister.phone_store.value"
                                                @inputValue="onChange($event, dataRegister.phone_store.id)"
                                                :error-text="dataRegister.phone_store.error"
                                                :is-error="dataRegister.phone_store.isError"
                                                @blur="validateFormUser($event, dataRegister.phone_store.id)"
                                                :required="dataRegister.phone_store.required"
                                        ></InputTextNormal>
                                    </div>
                                    <div class="col-sm-8">
                                        <InputTextNormal
                                                :label="dataRegister.addr_store.label"
                                                :id="dataRegister.addr_store.id"
                                                :placeholder="dataRegister.addr_store.placeholder"
                                                :value-default="dataRegister.addr_store.value"
                                                @inputValue="onChange($event, dataRegister.addr_store.id)"
                                                :error-text="dataRegister.addr_store.error"
                                                :is-error="dataRegister.addr_store.isError"
                                                @blur="validateFormUser($event, dataRegister.addr_store.id)"
                                                :required="dataRegister.addr_store.required"
                                        ></InputTextNormal>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-8 d-flex justify-content-center gap-5 mt-4">
                                <ButtonBackComponent :label="labelBtnStepBack" @click="backProcess(step)"></ButtonBackComponent>
                                <ButtonAddComponent :label="labelBtnStep" @click="nextStep(step)"></ButtonAddComponent>
                            </div>
                        </form>
                        <div class="col-sm-12 d-flex align-items-center flex-column text-center" v-if="step === 4">
                            <h5 class="card-title">ĐĂNG KÍ THÀNH CÔNG</h5>
                            <div class="card-body col-sm-12">
                                Quý khách đã đăng kí thành công tài khoản. <br>
                                Giờ đây quý khách có thể truy cập vào hệ thống để sử dụng dịch vụ <RouterLink to="/login">TẠI ĐÂY.</RouterLink>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<LoadingComponent v-if="isLoading"></LoadingComponent>
